import { createVNode as o, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/QuestionSquareFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return o(d, i(a, {
    icon: n
  }), null);
};
r.displayName = "QuestionSquareFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
